import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';
import fetchModel from 'epics/model/fetcher';

import type {
	FetchUiModificationsAction,
	FetchUiModificationsSuccess,
	FetchUiModificationsFailure,
} from 'state/actions/ui-modifications';
import {
	FETCH_UI_MODIFICATIONS_MODEL,
	fetchUiModificationsSuccess,
	fetchUiModificationsFailure,
} from 'state/actions/ui-modifications';
import type { ErrorResponse } from '../types';

export const uiModificationsEpic: Epic<
	FetchUiModificationsAction,
	FetchUiModificationsSuccess | FetchUiModificationsFailure
> = (action$) => {
	return action$.ofType(FETCH_UI_MODIFICATIONS_MODEL).mergeMap((action) => {
		const portalId = action.payload?.params?.portalId;
		const requestTypeId = action.payload?.params?.requestTypeId;

		// Guard clause: ensure required params are defined
		// If params are missing, don't emit any action (nothing meaningful to store)
		if (portalId === undefined || requestTypeId === undefined) {
			return Observable.empty<FetchUiModificationsSuccess | FetchUiModificationsFailure>();
		}

		return fetchModel(action.payload)
			.filter((response) => {
				return !!response.uiModifications;
			})
			.mergeMap(
				(response): Observable<FetchUiModificationsSuccess | FetchUiModificationsFailure> => {
					const uiModifications = response.uiModifications!;

					// Check if the response contains an error object
					if ('error' in uiModifications && uiModifications.error) {
						const error = uiModifications.error as { code?: string; message?: string };
						return Observable.of(
							fetchUiModificationsFailure(portalId, requestTypeId, {
								status: 500,
								errorMessages: [error.message || error.code || 'Unknown error'],
							}),
						);
					}

					return Observable.of(
						fetchUiModificationsSuccess(portalId, requestTypeId, uiModifications),
					);
				},
			)
			.catch((error: ErrorResponse) => {
				return Observable.of(fetchUiModificationsFailure(portalId, requestTypeId, error));
			});
	});
};
